webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(49);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueValidator = __webpack_require__(50);
	
	var _vueValidator2 = _interopRequireDefault(_vueValidator);
	
	var _App = __webpack_require__(42);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Home = __webpack_require__(46);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Farms = __webpack_require__(44);
	
	var _Farms2 = _interopRequireDefault(_Farms);
	
	var _Farm = __webpack_require__(43);
	
	var _Farm2 = _interopRequireDefault(_Farm);
	
	var _StarterKit = __webpack_require__(5);
	
	var _StarterKit2 = _interopRequireDefault(_StarterKit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueValidator2.default);
	
	var router = new _vueRouter2.default({
	  hashbang: false,
	  history: true,
	  transitionOnLoad: true,
	  root: '/',
	  linkActiveClass: 'uk-active'
	});
	
	router.map({
	  '/': {
	    name: 'home',
	    component: _Home2.default
	  },
	  '/farms': {
	    name: 'farms',
	    component: _Farms2.default
	  },
	  '/farms/:slug': {
	    name: 'farm',
	    component: _Farm2.default
	  },
	  '/kit': {
	    name: 'kit',
	    component: _StarterKit2.default
	  }
	});
	
	router.beforeEach(function () {
	  window.scrollTo(0, 0);
	});
	
	router.redirect({
	  '*': '/'
	});
	
	router.start(_App2.default, '#app');

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _firebase = __webpack_require__(23);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _vuefire = __webpack_require__(51);
	
	var _vuefire2 = _interopRequireDefault(_vuefire);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = new Object(null);
	var baseURL = 'https://kuza-staging.firebaseio.com/';
	
	_vue2.default.use(_vuefire2.default);
	
	exports.default = store;
	
	
	store.farms = new _firebase2.default(baseURL + 'farms');
	store.farmVisits = new _firebase2.default(baseURL + 'farmVisits');
	store.subscribers = new _firebase2.default(baseURL + 'subscribers');
	store.kits = new _firebase2.default(baseURL + 'kits');
	store.starterKitOrders = new _firebase2.default(baseURL + 'kitOrders');

/***/ },
/* 2 */,
/* 3 */,
/* 4 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(21)
	__vue_script__ = __webpack_require__(13)
	__vue_template__ = __webpack_require__(41)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Nav = __webpack_require__(47);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _Footer = __webpack_require__(45);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'AppView',
	  components: {
	    Navigation: _Nav2.default,
	    Foot: _Footer2.default
	  },
	  events: {
	    'selected-farm': function selectedFarm(farm) {
	      console.log('Farms just sent me an event');
	      this.$root.$broadcast('this-farm', farm);
	      console.log('I just sent an event to all my children');
	    }
	  }
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(3);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _store = __webpack_require__(1);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var payload = { channel: "#orders", text: "" };
	
	exports.default = {
	  name: 'Farm',
	
	  route: {},
	
	  data: function data() {
	    return {
	      farm: _store2.default.farm,
	      selectedDay: "",
	      user: {
	        name: "",
	        email: "",
	        phoneNumber: ""
	      },
	
	      confirmed: false
	    };
	  },
	
	
	  methods: {
	    confirm: function confirm() {
	      console.log(this.confirmed);
	      if (this.$paymentvalidator.paymentgroup.valid) {
	        console.log(this.farmVisit);
	        _store2.default.farmVisits.push(this.farmVisit);
	        payload.text = "Farm Visit Order\nname: " + this.user.name + "\nemail: " + this.user.email + "\nphone number: " + this.user.phoneNumber + "\nfarm: " + this.farm.title + "\nselected Day: " + this.selectedDay.day;
	
	        $.post("https://hooks.slack.com/services/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", (0, _stringify2.default)(payload));
	        this.confirmed = true;
	      }
	    },
	    back: function back() {
	      this.$router.go('/');
	    }
	  },
	  computed: {
	    farmVisit: function farmVisit() {
	      return {
	        user: {
	          name: this.user.name,
	          email: this.user.email,
	          phoneNumber: this.user.phoneNumber
	        },
	        farm: {
	          key: this.farm['.key'],
	          slug: this.farm.slug,
	          visitPrice: this.farm.visitPrice
	        },
	        selectedDay: {
	          day: this.selectedDay.day,
	          startTime: this.selectedDay.start,
	          endTime: this.selectedDay.end
	        }
	      };
	    }
	  }
	
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(1);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Farms',
	
	  firebase: {
	    farms: _store2.default.farms.limitToLast(25)
	  },
	  route: {
	    data: function data(transition) {
	      var _this = this;
	
	      window.setTimeout(function () {
	        if (_this.farms.length) transition.next();
	      }, 3000);
	    }
	  },
	  methods: {
	    openFarm: function openFarm(farm) {
	      _store2.default.farm = farm;
	      this.$router.go({
	        name: 'farm',
	        params: {
	          slug: farm.slug
	        }
	      });
	    }
	  }
	
	};

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Footer'
	};

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(1);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _StarterKit = __webpack_require__(5);
	
	var _StarterKit2 = _interopRequireDefault(_StarterKit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Home',
	  components: {
	    StarterKit: _StarterKit2.default
	  },
	  backgroundUrl: '../assets/images/header.jpg',
	  data: function data() {
	    return {
	      subscribed: false,
	      email: ''
	    };
	  },
	
	  methods: {
	    subscribe: function subscribe(event) {
	      event.preventDefault();
	      _store2.default.subscribers.push(this.email);
	      this.subscribed = true;
	    }
	  }
	};

/***/ },
/* 11 */
/***/ function(module, exports) {

	"use strict";
	
	$(document).ready(function () {
	  document.getElementById("paradeiser-dropdown").addEventListener("click", function (event) {
	    event.preventDefault();
	
	    document.getElementById("paradeiser-more").classList.toggle("open");
	  });
	
	  document.getElementById("greybox").addEventListener("click", function (event) {
	    event.preventDefault();
	
	    document.getElementById("paradeiser-more").classList.remove("open");
	  });
	
	  var myElement = document.querySelector(".paradeiser");
	  var headroom = new Headroom(myElement, {
	    tolerance: 5,
	    onUnpin: function onUnpin() {
	      document.getElementById("paradeiser-more").classList.remove("open");
	    }
	  });
	  headroom.init();
	});

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(3);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _store = __webpack_require__(1);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var payload = { channel: "#orders", text: "" };
	
	exports.default = {
	
	  name: 'PaymentModal',
	
	  props: ['totalPrice'],
	
	  data: function data() {
	    return {
	      user: {
	        name: "",
	        email: "",
	        phoneNumber: ""
	      },
	
	      confirmationCode: "",
	      confirmed: false
	    };
	  },
	
	
	  methods: {
	    confirm: function confirm() {
	      if (this.$paymentvalidator.paymentgroup.valid && !this.confirmed) {
	        _store2.default.starterKitOrders.push(this.starterKitOrder);
	        payload.text = "Kit Order\nname: " + this.user.name + "\nemail: " + this.user.email + "\nphone number: " + this.user.phoneNumber + "\namount: " + this.totalPrice;
	        $.post("https://hooks.slack.com/services/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", (0, _stringify2.default)(payload));
	        this.confirmed = true;
	      }
	    }
	  },
	
	  computed: {
	    starterKitOrder: function starterKitOrder() {
	      return {
	        user: {
	          name: this.user.name,
	          email: this.user.email,
	          phoneNumber: this.user.phoneNumber
	        },
	        amount: this.totalPrice
	      };
	    }
	  }
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(1);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _PaymentModal = __webpack_require__(48);
	
	var _PaymentModal2 = _interopRequireDefault(_PaymentModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  name: "Starter-Kit",
	  data: function data() {
	    return {};
	  },
	
	
	  components: {
	    PaymentModal: _PaymentModal2.default
	  },
	
	  firebase: {
	    kits: _store2.default.kits.limitToLast(25)
	  },
	
	  filters: {
	    currency: function currency(value) {
	      return value + ' /=';
	    }
	  }
	};

/***/ },
/* 14 */,
/* 15 */,
/* 16 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 17 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 18 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 19 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 20 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 21 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 22 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 23 */,
/* 24 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA5dJREFUeNrsW01oE0EUfgmFCgUbEFooWGMRQaQQqRcLpRvwohfTk6DQpJdeYw6CB6ENehA8NKU3L4kHBU9NL9aD2BSheilEihS0lFih0IKSigULHnxvmYUI+ZmdnZnN/nwwTA6b3f2+982bmZ0ZgBAhQgQZEdUPePr+ZgwrA0sCyzks8TaXV7F8w1K5P/G66lkBkDSRzDYQF0GdhMCygmKUPCEAEs9glWbEZYLEIBEWUYxa1wmAxFNYLXSwtyyQEDkUou66AMzqRQUR53FEHkUouCYAizqRj7mYxMtYZpy4ISJInux+r0t6MsoJU6K9RkSAPEU902XdOTkgKSJCxAfkHYkQ8Ql5YREinOTnsZrzyOiWRDjPmxijHOQND5EH1ist814c5RjHL4u+SW9PH4wN3YL+U4O6RTCYax07YMFJPz82lILkyCxMJ5ZMITRjjg3UxARg1peS9MgJJMTt0Sfmb40oOnGA9HZ/tn8UZq8W4cKZazqbgmFbAPxTQtX4nhyQuvTQLJrckBVxQFb1W5ELNLkh1S4XRFtk/pSO0FhuuHExp9oNGTsOSOme4V0euA7pK0tmjlCEtB0BJt0YvZzuHTR7CeotFLgh3qoZNBPAABdB4wVFbjA6CsBUioPLsNwwPnxX5m0neRzgOvlGjA/fgWl0w0DfiJRmwCOAAV0GIk8iSHBDQmg26CM3xDwtgOUGyg0yJ1aeEqBxYkUlkALIRo/XXvjk7zFs7L2Azf2V4AlweLwLb74smLUqB9S7lfzG3ksz8g5Q5xGg6uOoV3kEqPks6h0F+K8XYGvvrovw6+QAXm09kEme8Ik3CVbAxRUgyu5EnLK9ZFR4BVh3QwCK+iq29e9HWypuX2u1s6SZALTm7mg9wC4+H76Fd7vPVETdwnPukSBbUyvrGtSUtx+bkVdInlCyOxBaVN0Mdn58gNWvyombjm63sarpXIAtL1dURp2KBvJWMIWGwnnZH0gowZW3H+kibkW/IjQbZH8syYr6GiY56ts1kifknE6G6AbC6wSb+2Uk/Bt2fn6Eoz8HunvWPM+myo47RNji4prHZs201zgp5YMIawp5D5GnbnyK92KuL0IowrysfKCBfNLOxslwm5zdp/hto6Ttj6L4kBmsCl1EviZKXsgBDU4I7mbpBhHiENTt8k3coOvARIGRd//ARBMhKDkG78hMi6YRvENTLcSwc2xu3SKu69hciBAhgo1/AgwArYxnWMtze0kAAAAASUVORK5CYII="

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/farm-visit.433a8d4.jpg";

/***/ },
/* 26 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 27 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABOVJREFUeNrsWm1sU2UUPtvarqPr1rEoEiK4TTcyEOeWuBkzxCwmGtCo0QQSjVsyEvmBwA9NZDESI4shJjj5wQ+W4A+TmaiRIIRosuBHBGakDtwwFNgYOFa+ss52rGVt53le7i633e3HujVret8neXPv3e69vec5z3Pecz+IJCQkJCQkJCQMipz5PuFLjU818+LtNF1vxw+//XEoIwngwB282MujOc1J+5LHDibCkzEEcPA1vDjIo6bs0Up6+Y2N1LlvL437vGSy5lDFhkKyluTOOC44MUXnv/VS0D8lth3lZlrRtEj3N26du0vDv09Mb/byaGESehecAEXyyLyj6cX11Lp1B9kK7SL49rb36e+/nIKEqtftVFptmUkCB3/uq//IMzCpklD9ZpE4Jhq3mQQtYYoSPl8QAhTJI+uvIGAEDgKicfibr4UagGXPFFDFepvu+ZDdS0fHxTqCX/VWERWXmWfs5x8Nk+s7r0oY45CihpQskTcHyR/n0QDJt7Xvodr6p3X3rVq1mhoanyVnzyly/zMqslhSaSFTQST3RcvNQiGjFybpri9M150BVRFa4LgltVaxPjYoSFjJY2PVimW/uK4Mu9NOAAe/nRff49rgdQRfsrg07jH4P9QxfGWIBvoHOTg/LXrAxCPy5y32XFpSZ6U7N0M0wQMBYpRW51OuKZIwEIMBQsNBghrfYRLGmIRTaSEAkucf6OLV7ZD8ex99IopdsrBY8qmx6XlRH/48cZJung0ILyPz2uCw/uCafGEDqAGSH+nxi/2sJZGXi+2l9QXkvRoU+zFe4Gus4fEjE+GfNwKiJd/+xX4h7VQQbYlR1yTZl5tE9hNZAoQtrowspCAshiXOMAmX50yAnuSRxbkg2hJQg8WeR4VLTXEtgUzHqiE6lmhmEnKYhJ9TmgWUKo/A1yHgbR98KDI33+g+dlTtGZDJig023SkQCrh0xCdUkGhaxVQJIhSAgFdjzRJ5MYJfx4uTkNPjT9bSrs86UpZ8IpQ/Vkl19Q10vr+f/u2/HtMSUAcyL/zuCas1RM8S2hrCeEQpkD16lsjTCX6XMr9bIXkUu7lKPhlLrOUCGcsSvpEgTdwK0VSQa8PDZmEH1IVoS4AQ/C3ABIFAHK+QYI1liRydzB/PlDu12q0OsXTui9/jwPtrWotFI6Vpl2PhObaDSoJJbw/IfnVNXdyz9PWeFm3uppbNSQVzw31N+H025w5xRm2cRXg9dL/9jbiXgDpUIrhzHNdsa+G7FtS20BSXAFzgppbWuBfZxSa5R0BrUgT09ToFAbM5t9oW872BHjDtnTkwpm6DKL3CCJztHNO2z/drhtEfiEgCJAGSAEmAJMDIMKV6A9N97IhYb9u2JaljfF6fVEDWKAD38jfcI9yxHaDdHfuT7gR3vrvFWAoIhX1iZJ0CkkXf0Gti+UTZT8YkINOzL4ugJCDNFih/6FNjE+Cwrc1OAgYvusRjK6DrYGdSx+CRWNYQgKCnH1mhGTJcDdi5e48gAcEf/rVHdoJyGpTT4MIAX5Dgi5PicrMxCQDw2Y1hLYCPIk58fFv9tshwBAQ8IfG6K9brMFkEU60B6NowbyfT2SXabxoDF1yzPrf7dED3fZ7WAtPLoe47Ce2ih4x+PZ4mxH09fpnufXjoyNLgPUqMEhISEhISEhIS/wswAID2TUCYEWHYAAAAAElFTkSuQmCC"

/***/ },
/* 28 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo-small-white.3a36fbf.png";

/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAAoCAYAAAA16j4lAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABJNJREFUeNrsWr1u2zAQloOMBaoxWzRkj7IHqPMEsYfOtZ8g9lR0cowORSc7Q6cOtucWsIIu7aT0CeI8gT1miwt0d+/SU8EwR4q29UeXBxCyJVIU+fHuvjvS85w4ceLESQby4Uu7ASXM8p37blorAWwdLj0oeG1CmTmAdw/YRFCDIwew3cD6BGwn774cwMWDG8BlSpqau+y5Kc8UvAMDzU0Dd+E0uLryFkDE6+Td6xFHlAYGmpspwDWHSaYa/A0uL+gvAvwRgL4XTPM87R1QP1NMnInOVu4lNvwZgD2i/w2D9lHWH+QAzlZ+S/9Rm9/T71cG7a8rD/BqtWpBiaHcQrlcs+2A2mH7loUA3zH3DkCLTw187wzM87jSYRKAgoMYiWYK7i1rtdrQoC22E0Gtw70ZtJ1ZBPB3KG+Y+8dQAk27JZS2DWES52fONwA3Ed8m9SVC9ZV5dJQCblfBuu33wRpwMw8ZCgL5kwJkTm6gnOVhmisRB6eA2wbzbB3ACcjgd3/Az1OBXf+StDaCenaND0nV6rnEKnBXarGRYFVS9iqquWObJxXG50NBkhiU/S37ZWi5Alw0W00A90YVfgkMHQnJGdRdavqZCqRvCHW7yeR7f3dy1k32Y58TjtUTkBfUXyA9E/3txOrFm2aiKUbm5IFCLN27Zelo6jaY+qEQa28qD4rYfR25pUW2WyZa0kBZc8908S6aO+a2LjMUakKubcymLy5EcjXr7uli++lOmWgNuChXGyYzNtWCvkF7X7FIFsm3EtCcq0ET/JNCPJ/yAHI99M9hEUmcIgDGiahrnvdgsFFRGSvqp5myIGMVR0hJ6pww44jIDz8D2cvw7FWZJtpE00YV4hEjxYJsSuDJBK+vWaSTDC1Q5RMdS2ZwmLMeJEy3RHA7CrPbltk95teh/iFZKMyZX6pCJq+g4zlVADgxjzFDdjowGdeqMKkgnjBgHnVVoQ23IMk3h0QCwzLBLRrgf7ErTEJXwSQxu3Wii29zArehcBPjtJ0wioFbBGj9f81kPUlMwBVPLnCnF4Ki/TGzxSmC2zZI2sy952ebZYl2GeCFIuvUZojKIzsljSoK3JjhBDMDcDsELDdeBLRL4655Oe31VsVELziTS6a6rTHVsy12k44NwE2OsPqctTHoo6fw10PDxMtOmWhVTKoy1b6BqQ5SYu80cDmit/RSctzUvs4sDJ2/5r715c4DnKx6hamuJ/lmBbMOuBQmxbFBSp/c4XMjcDeUi7K0uvSD72iGAZS+IkTBLNeYJp2Ln6fEyBf07CKNyWoSGTeG/n+s4Q5P0q7EsEcKMEPPNllnw59pGyt2XzoJMKvt5DH/u9peHuh75ornU5qH2OBdoW0meml4jxMV0/RTTDnXX54ZsWRHSdVHgwmb0DoMFXWt0uCA9nZFaWxpAVpiWEP7qSqJhX3fubTf7NP96ZYafCsmSJjxijKXvl/+9twTI7UcQA7JF+KETogpr5tVOqf211yakOpgP4eksXigLZL8XyiQmyvm2UbJfpnw0cJpUGgW0vfcUSwdMXV7RAKvykrLOnHixBb5I8AAsYzDFva0dmEAAAAASUVORK5CYII="

/***/ },
/* 31 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAg9JREFUeNrsmD1Lw1AUhk/SNk1sRLGgtqg4iLj4C1wsLg4OLg6CoO6KipuLurj6sQtdRMGlv8D2J7jU2S9Q62DFVtqi1RNNpBRLkzaS1LwvHJK093LPee45p7chgiDHtDwV69TMSR8EpwLnyyrbSk8kQoqixPl+f/3g8PJfA+DAB/myybZgfNYbjZIsy8ajAeL8XwHgwMe13Wabrv6uCoChlA4i0dIAOHBtp+fZxmuNqQHAkFYS2wwi3jIA9Pqe1lN9sN74OgAMZbWMYNtjGFnXAuDgt/RUN93ZTQKoBJFgCIt2+SzanACbVoJvQJ2VDdSNAFpOAAAAAOBtCb+c2JpR0swgf4fwZZq6wmGSpCDRq48o7zO7TqwZJ/lnNPXjSyMBNKvQqJ86xoylc1RmEy7aSUirtoI2s/HoAQDgcfmdWLR4/U7P+r2qquQPBEjISN4BULguf5kmJapQwPyfIZSAoxnQ3TdAclvIVge+zwH2pX+pWKBs5v5vAEzMzFH/8Iird/Tx5pKSJ3GUAAAAwB/0gIfbK9sdkIISiaJ9+/BkoQFaBnB2emQ7AIsvRVECAOBkD5hd28A5ACUAAADg3SZ4vLuDcwBKwMslUE+TSyXLc9K5F/oQ85bmCKmwOwH0DpUtz7m4e6MPi3MElAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEQQ3pU4ABAD0eakYT82UlAAAAAElFTkSuQmCC"

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/starter-kit.0ec2f61.png";

/***/ },
/* 33 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 34 */
/***/ function(module, exports) {

	module.exports = " <navigation></navigation> <div class=\"\"> <router-view></router-view> </div> <foot></foot> ";

/***/ },
/* 35 */
/***/ function(module, exports) {

	module.exports = " <div class=\"uk-container uk-container-center uk-margin-top uk-margin-large-bottom main-container\"> <ul class=uk-breadcrumb> <li><a href=#!/ >Home</a></li> <li><a href=#!/farms>Book a Visit</a></li> <li class=uk-active><span>{{farm.title}}</span></li> </ul> <div class=uk-grid data-uk-grid-margin> <div class=uk-width-1-1> <h2>{{ farm.title }}</h2> <p>Instructed by: {{ farm.expert.name }} </p> </div> <div class=\"uk-width-medium-1-2 uk-margin-top\"> <div class=uk-slidenav-position data-uk-slideshow=\"\"> <ul class=uk-slideshow style=\"\"> <li v-for=\"image in farm.images\" track-by=$index> <img :src=image width=100% height=50% alt=\"\"> </li> </ul> <a href=# class=\"uk-slidenav uk-slidenav-contrast uk-slidenav-previous\" data-uk-slideshow-item=previous style=\"color: rgba(255,255,255,0.4)\"></a> <a href=# class=\"uk-slidenav uk-slidenav-contrast uk-slidenav-next\" data-uk-slideshow-item=next style=\"color: rgba(255,255,255,0.4)\"></a> <ul class=\"uk-dotnav uk-dotnav-contrast uk-position-bottom uk-flex-center\"> <li :data-uk-slideshow-item=index v-for=\"index in farm.images.length\"> <a href=\"\"></a> </li> </ul> </div> </div> <div class=\"uk-width-small-1-1 uk-width-medium-1-2\"> <div class=uk-panel> <div class=\"uk-grid uk-text-align\" data-uk-grid-margin> <div class=uk-width-1-1> </div> <div class=uk-width-1-1> <div class=uk-align-right style=\"font-size:1.5em; padding:10px; background-color: #AED47B; color: #ffffff\"> {{ farm.visitPrice }} </div> <h3> <i class=\"uk-icon uk-icon-clock-o\"></i> Duration: <span class=uk-margin-left> {{ farm.duration }} </span> </h3> <h3> <i class=\"uk-icon uk-icon-map-marker\"></i> Location: <span class=uk-margin-left> {{ farm.location }} </span> </h3> </div> <div class=uk-width-1-1><a href=#payment-modal class=\"uk-button uk-button-large uk-button-primary uk-align-center\" data-uk-modal><i class=uk-icon-card></i>Book Now</a></div> </div> </div> </div> <div class=uk-width-1-1> <ul class=uk-tab data-uk-tab=\"connect:'#farm-tab'\"> <li class=uk-active><a href=\"\">Description</a></li> <li><a href=\"\">Farm Expert</a></li> </ul> <ul id=farm-tab class=\"uk-switcher uk-margin\"> <li> <dl class=uk-description-list-line> <dt><strong> Description </strong></dt> <dd> {{ farm.description }} </dd> </dl> </li> <li> {{ farm.expert.name }} </li> </ul> </div> </div> <div> </div> <div id=payment-modal class=uk-modal> <div v-show=!confirmed> <validator name=paymentvalidator :groups=\"['paymentgroup']\"> <div class=uk-modal-dialog> <a class=\"uk-modal-close uk-close\"></a> <ul> <li v-for=\"error in $paymentvalidator.errors\"> <p>{{error.field}}: {{error.message}}</p> </li> </ul> <h3><strong>Please confirm the details below</strong></h3> <div class=\"uk-accordion uk-margin-top\" data-uk-accordion> <h3 class=uk-accordion-title>Select a date to visit<i class=\"uk-align-right uk-icon-small uk-icon-caret-down\"></i></h3> <div class=uk-accordion-content> <h3 class=uk-panel-title>Open <strong>Weekly</strong> on: <span class=\"uk-h5 uk-align-right\">(Choose one of the days)</span></h3> <ul class=\"uk-list uk-list-striped\"> <li v-for=\"date in farm.dates\"><label><input type=radio :name=day :value=date v-model=selectedDay> {{ date.day }} <span class=uk-align-right>{{ date.start }} - {{ date.end }}</span></label> </li> </ul> </div> <h3 class=uk-accordion-title>Your Details<i class=\"uk-align-right uk-icon-small uk-icon-caret-down\"></i></h3> <div class=uk-accordion-content> <form class=uk-form data-uk-margin> <div class=uk-form-row> <label class=uk-form-label>Your Name</label> <input v-model=user.name class=uk-form-width-large placeholder=\"e.g. John Simba\" v-validate:name=\"{ required: true, message: 'please put your name so that we can be friends :)' }\" initial=off :classes=\"{ valid: 'uk-form-success', invalid: 'uk-form-danger' }\" group=paymentgroup required> </div> <div class=uk-form-row> <label class=uk-form-label>Email Address</label> <div class=uk-form-icon><i class=uk-icon-inbox></i> <input type=email v-model=user.email class=uk-form-width-large placeholder=\"e.g. you@youremail.com\" v-validate:email=\"{ required: true, message: 'email requires an @ and a .', pattern: '/^[-a-z0-9~!$%^&*_=+}{\\'?]+(\\.[-a-z0-9~!$%^&*_=+}{\\'?]+)*@([a-z0-9_][-a-z0-9_]*(\\.[-a-z0-9_]+)*\\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}))(:[0-9]{1,5})?$/i' }\" initial=off :classes=\"{ valid: 'uk-form-success', invalid: 'uk-form-danger' }\" group=paymentgroup required> </div> </div> <div class=uk-form-row> <label class=uk-form-label>Phone Number</label> <div class=\"uk-form-icon uk-margin-small-top\"><i class=uk-icon-phone></i> <input type=tel v-model=user.phoneNumber class=uk-form-width-large placeholder=\"e.g. 0712123456\" v-validate:phonenumber=\"{ required: true, message: 'we will only use your number for good' }\" initial=off :classes=\"{ valid: 'uk-form-success', invalid: 'uk-form-danger' }\" group=paymentgroup required> </div> </div> </form> </div> <h3 class=uk-accordion-title>Farm Visit Summary<i class=\"uk-align-right uk-icon-small uk-icon-caret-down\"></i></h3> <div class=uk-accordion-content> <div class=uk-grid data-uk-grid-margin> <div class=uk-width-1-10><i class=\"uk-icon-justify uk-icon-large uk-icon-map-marker\"></i></div> <div class=uk-width-9-10> <h3 class=uk-align-right>{{ farm.location }}</h3></div> <div class=\"uk-width-1-10 uk-margin-top\" v-show=selectedDay><i class=\"uk-icon-justify uk-icon-large uk-icon-clock-o\"></i></div> <div class=\"uk-width-9-10 uk-margin-top\" v-show=selectedDay> <h3 class=uk-align-right>{{ selectedDay.day }}, {{ selectedDay.start }} - {{ selectedDay.end }}</h3></div> <div class=uk-width-1-10><i class=\"uk-icon-justify uk-icon-large uk-icon-money\"></i></div> <div class=uk-width-9-10> <h3 class=uk-align-right>{{ farm.visitPrice }}</h3></div> </div> </div> <div class=\"uk-form-row uk-width-1-1\"> <p></p> <button class=\"uk-button uk-button-primary uk-button-large uk-align-center\" type=button v-if=$paymentvalidator.paymentgroup.valid v-on:click=confirm>Book a Visit</button> </div> </div> </div> </validator> </div> <div v-if=confirmed> <div class=uk-modal-dialog> <a class=\"uk-modal-close uk-close\"></a> <div class=\"uk-align-center uk-text-center\"> <h2>Thanks for your order</h2> <i style=\"color: #87AB61\" class=\"fa fa-check-circle fa-5x\"></i><br> <h3>A Kuza representative will get back to you soon</h3> <h3>For inquiries call Isaac at</h3> <h2>+254718411704</h2> <h3>Or email</h3> <a href=mailto:farm@kuza.io><h2>farm@kuza.io</h2></a> </div> </div> </div> </div> </div> ";

/***/ },
/* 36 */
/***/ function(module, exports) {

	module.exports = " <div class=\"uk-container uk-container-center uk-margin-top uk-margin-large-bottom main-container\"> <ul class=uk-breadcrumb> <li><a href=#>Home</a></li> <li class=uk-active><span>Book a Visit</span></li> </ul> <div class=uk-grid data-uk-grid-margin> <div class=uk-width-1-1> <h1>Book a Farm Visit</h1> <p class=uk-text-large>Visit one of our partner farms to learn the basics of farming <button class=\"uk-button-mini uk-button-primary uk-button uk-margin-left\" data-uk-modal=\"{target:'#more',center:true}\"> Learn More </button> </p> <div id=more class=uk-modal> <div class=uk-modal-dialog> <a class=\"uk-modal-close uk-close\"></a> <div class=\"uk-modal-header uk-text-center\"><h2>Farm Visit FAQ</h2></div> <ol> <li> <strong> What is a farm visit?</strong> <p>It is a learning experience at one of our partner farms where you get to interact with experts and learn the best practices from them</p> </li> <li> <strong> How do I view a farm?</strong> <p> Click on one of the farms </p> </li> <li> <strong> How many farms are there on Kuza? </strong> <p>We are currently working on bringing more quality farms onto our platform.</p> </li> <li> <strong> I have a farm. How do I get it listed on Kuza?</strong> <p> Call <a href=tel:+254718411704>+254718411704</a> or email <a href=mailto:farm@kuza.io> farm@kuza.io </a> and we'll get back to you. </p> </li> </ol> <div class=\"uk-modal-footer uk-text-center\"></div> </div> </div> </div> <div v-if=$loadingRouteData class=\"uk-align-center uk-vertical-align\" style=\"height: 50vh\"> <div class=uk-vertical-align-middle> <i style=\"color: #87AB61\" class=\"uk-icon-circle-o-notch uk-icon-large uk-icon-spin\"></i> </div> </div> <div v-if=!$loadingRouteData class=\"uk-width-medium-1-2 uk-grid-margin uk-row-first\" v-for=\"farm in farms\" transition=expand> <div class=\"uk-panel uk-panel-box-hover\"> <div class=uk-panel-teaser> <figure class=\"uk-overlay uk-vertical-align\"> <img :src=farm.images[0] alt=\"\" data-src=farm.images[0] data-holder-rendered=true> <figcaption class=\"uk-overlay-panel uk-overlay-background uk-overlay-bottom uk-vertical-align-middle\"> <h3>{{farm.title}}</h3> <p class=uk-text-truncate v-if=farm.description>{{farm.description}}</p> <p> <span class=uk-align-left v-if=farm.duration><i class=\"uk-icon-clock-o uk-icon-small uk-margin-right\"></i>{{farm.duration}}</span> <span class=uk-align-right v-if=farm.location><i class=\"uk-icon-map-marker uk-icon-small uk-margin-right\"></i>{{farm.location}}</span> </p> </figcaption> </figure> </div> <a class=uk-position-cover v-on:click=openFarm(farm)></a> </div> </div> </div> </div> ";

/***/ },
/* 37 */
/***/ function(module, exports) {

	module.exports = " <div class=\"uk-block uk-block-muted footer\"> <div class=uk-container> <div class=\"uk-grid uk-grid-match uk-align-center\" data-uk-grid-margin=\"\"> <div class=\"uk-width-medium-1-4 uk-row-first\"> <div class=uk-panel> <h2 class=uk-panel-title>Product</h2> <a href=https://kuza.teachable.com target=_blank><p>Courses</p></a> <a v-link=\"{ path : /farms }\"><p>Farm Visits</p></a> <a href=\"\"><p>Farm Inputs</p></a> <a href=\"\"><p>Starter Kits</p></a> </div> </div> <div class=\"uk-width-medium-1-4 uk-row-first\"> <div class=uk-panel> <h2 class=uk-panel-title>Your Account</h2> <a href=https://kuza.teachable.com/sign_in target=_blank><p>Login</p></a> <a href=https://kuza.teachable.com/sign_up target=_blank><p>Sign Up</p></a> <a href=\"\"><p>Security</p></a> <a href=\"\"><p>Terms of Service</p></a> <a href=\"\"><p>Privacy Policy</p></a> </div> </div> <div class=\"uk-width-medium-1-4 uk-row-first\"> <div class=uk-panel> <h2 class=uk-panel-title>Company</h2> <a href=/about><p>About</p></a> <a href=https://blog.kuza.io target=_blank><p>Blog</p></a> <a href=/contact><p>Contact</p></a> <a href=/press><p>Press Kit</p></a> </div> </div> <div class=\"uk-width-medium-1-4 uk-row-first\"> <div class=uk-panel> <h2 class=uk-panel-title>Contact Us</h2> <a href=tel:+254718411704><h2>+254718411704</h2></a> <a href=mailto:farm@kuza.io><p>farm@kuza.io</p></a> <a href=https://twitter.com/kuzahub class=twitter-follow-button data-show-count=true>Follow @kuzahub</a> <p> </p><div class=fb-like data-href=https://www.facebook.com/kuzahub data-layout=button_count data-action=recommend data-show-faces=true data-share=true></div> <p></p> </div> </div> </div> </div> </div> <div class=uk-block-secondary> <div class=\"uk-container uk-text-center\"> © 2016 Kuza.io </div> </div> ";

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = " <div class=uk-grid data-uk-grid-margin> <div class=\"uk-width-medium-1-1 header\"> <div class=\"uk-vertical-align uk-text-center\" style=\"background: url('../assets/images/header.jpg') 50% 0 no-repeat; height: 90vh\"> <div class=\"uk-vertical-align-middle uk-width-medium-2-3\"> <h1 class=uk-heading-large>Farming Just Got Simpler</h1> <p class=uk-text-large>KUZA provides you with detailed online farming video courses, one-on-one support and on-farm services to make sure you succeed in your next farming venture.</p> <p> <a class=\"uk-button uk-button-primary uk-button-large\" href=#starter-kit data-uk-smooth-scroll> Get a Starter Kit </a> </p> </div> </div> </div> </div> <div class=\"uk-container uk-container-center uk-margin-top uk-margin-large-bottom main-container\"> <div class=uk-grid data-uk-grid-margin> <div class=\"uk-width-1-1 uk-text-center uk-margin-top uk-margin-bottom\"> <h2>We are a One-Stop Platform for All Things Farming</h2> <hr> </div> <div class=\"uk-width-medium-1-2 one-stop\"> <div class=uk-grid> <div class=uk-width-1-6> <img src=" + __webpack_require__(24) + "> </div> <div class=uk-width-5-6> <h2>Online Video Courses</h2> <p>We offer you detailed short video courses for the best learning experience. The content is curated from the best experienced farmers and farm experts.</p> </div> </div> </div> <div class=\"uk-width-medium-1-2 one-stop\"> <div class=uk-grid> <div class=uk-width-1-6> <img src=" + __webpack_require__(33) + "> </div> <div class=uk-width-5-6> <h2>Dedicated Support</h2> <p>Get help and support by engaging with experienced farmers and experts directly on Kuza. Join our farming forums to share, interact and learn from other farmers.</p> </div> </div> </div> <div class=\"uk-width-medium-1-2 one-stop\"> <div class=uk-grid> <div class=uk-width-1-6> <img src=" + __webpack_require__(4) + "> </div> <div class=uk-width-5-6> <h2>On-farm Support</h2> <p>We offer you access to professional support on the farm from trusted experts in extension services during your initial stages of farming to help you get started.</p> </div> </div> </div> <div class=\"uk-width-medium-1-2 one-stop\"> <div class=uk-grid> <div class=uk-width-1-6> <img src=" + __webpack_require__(27) + "> </div> <div class=uk-width-5-6> <h2>Professional Farm Services</h2> <p>Access other farm services to help you succeed in farming, including farm visits, access to farm inputs, labour, farm managers, agronomists and other farm services.</p> </div> </div> </div> </div> <hr class=\"uk-grid-divider uk-margin-large-top uk-margin-large-bottom\"> <div class=uk-grid data-uk-grid-margin> <div class=uk-width-medium-1-2> <h2>Mushroom Farming</h2> <p>This course gives you detailed tutorials on what mushroom farming is all about, and how you can easily get started with support from experienced farmers and experts.The course is offered to you by Kuza in association with the Potentate farms and mushroom complex.</p> <a class=\"uk-button uk-button-primary uk-button-large\" href=https://kuza.teachable.com/courses/mushroom-farming-in-kenya target=_blank>Learn More</a> </div> <div class=uk-width-medium-1-2> <video width=660 height=400 class=uk-thumbnail autoplay muted controls> <source src=http://embed.wistia.com/deliveries/f72e6fa804f9849902bdbf4891c91a1804cab699/file.mp4 type=video/mp4> </video> </div> </div> <hr class=\"uk-grid-divider uk-margin-large-top uk-margin-large-bottom\"> <div class=uk-grid data-uk-grid-margin> <div class=uk-width-medium-1-2> <img width=660 height=400 class=uk-thumbnail src=" + __webpack_require__(25) + " alt=\"\"> </div> <div class=uk-width-medium-1-2> <h2>Farm Visits</h2> <p>Book a visit on one of our partner farms. Farm visits are a great way to get on the ground fast and start learning from the real experts one to one. You will learn the best practices to farm mushrooms, onions, tomatoes and other crops.</p> <a class=\"uk-button uk-button-primary uk-button-large\" v-link=\"{ path: '/farms' }\"><i class=\"uk-icon uk-icon-calendar-check-o\"></i> Book a Farm Visit</a> </div> </div> <hr class=\"uk-grid-divider uk-margin-large-top uk-margin-large-bottom\" id=starter-kit> <div class=uk-grid> <div class=uk-width-medium-3-5> <h2>Starter Kits</h2> <p>Our starter kits contain everything you need to get started farming. We put our courses and services together into an affordable bundle</p> <img class=\"uk-align-center uk-margin-top uk-margin-bottom\" width=400px src=" + __webpack_require__(32) + "> </div> <div class=uk-width-medium-2-5> <starter-kit></starter-kit> </div> </div> <hr class=\"uk-grid-divider uk-margin-large-top uk-margin-large-bottom\"> <div class=uk-grid data-uk-grid-margin> <div class=uk-width-medium-1-1> <div class=\"uk-panel uk-panel-box uk-panel-large uk-text-center\"> <form class=uk-form> <fieldset data-uk-margin> <strong class=\"uk-margin-right uk-text-large\" v-show=!subscribed>Get personalized farming tips in your inbox</strong> <input type=email placeholder=you@youremail.com class=uk-input v-model=email v-show=!subscribed required> <button class=\"uk-button uk-button-primary uk-margin-left\" v-on:click=subscribe($event) v-show=!subscribed>Subscribe</button> <strong class=\"uk-margin-right uk-text-large\" v-show=subscribed>Thank you for subscribing!</strong> </fieldset> </form> </div> </div> </div> <div class=uk-grid data-uk-grid-margin> <div class=\"uk-width-1-1 uk-text-center uk-margin-top uk-margin-bottom\"> <h2>Work with the best in the industry</h2> <hr> </div> <div class=\"uk-width-medium-1-4 uk-text-center\"> <img src=" + __webpack_require__(26) + "> <h3>Experienced Farmers</h3> </div> <div class=\"uk-width-medium-1-4 uk-text-center\"> <img src=" + __webpack_require__(4) + "> <h3>Sector Experts</h3> </div> <div class=\"uk-width-medium-1-4 uk-text-center\"> <img src=" + __webpack_require__(31) + "> <h3>Institutions & Organizations</h3> </div> <div class=\"uk-width-medium-1-4 uk-text-center\"> <img src=" + __webpack_require__(28) + "> <h3>Agric. Investors</h3> </div> </div> <hr class=\"uk-grid-divider uk-margin-large-top uk-margin-large-bottom\"> </div> ";

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = " <div class=uk-padding> <nav class=\"paradeiser opaque-nav\"> <a v-link=\"{ path: '/' }\"> <img src=" + __webpack_require__(30) + " alt=Logo class=\"paradeiser_logo uk-hidden-small\"> <img src=" + __webpack_require__(29) + " alt=Logo class=\"paradeiser_small_logo uk-visible-small\"> </a> <a href=https://kuza.teachable.com target=_blank> <div class=paradeiser_icon_canvas> <i class=\"uk-icon uk-icon-play-circle uk-icon-medium\"></i> </div> <span>Courses</span> </a> <a v-link=\"{ path: '/farms' }\"> <div class=paradeiser_icon_canvas> <i class=\"uk-icon uk-icon-calendar-check-o uk-icon-medium\"></i> </div> <span>Book a Visit</span> </a> <div class=paradeiser_dropdown> <a href=#paradeiser-more id=paradeiser-dropdown> <div class=paradeiser_icon_canvas> <i class=\"uk-icon uk-icon-bars uk-icon-medium\"></i> </div> <span>More</span> </a> <ul class=paradeiser_children id=paradeiser-more> <li><a href=https://blog.kuza.io target=_blank>Blog</a></li> <li><a href=#/about>About Us</a></li> <li><a href=#/contact>Contact Us</a></li> <li id=greybox><a href=#!></a></li> </ul> </div> </nav> </div> ";

/***/ },
/* 40 */
/***/ function(module, exports) {

	module.exports = " <div v-show=!confirmed> <validator name=paymentvalidator :groups=\"['paymentgroup']\"> <div class=uk-modal-dialog> <a class=\"uk-modal-close uk-close\"></a> <ul> <li v-for=\"error in $paymentvalidator.errors\"> <p>{{error.field}}: {{error.message}}</p> </li> </ul> <h3><strong>Please confirm the details below</strong></h3> <div class=\"uk-accordion uk-margin-top\" data-uk-accordion> <h3 class=uk-accordion-title>Your Details<i class=\"uk-align-right uk-icon-small uk-icon-caret-down\"></i></h3> <div class=uk-accordion-content> <form class=uk-form data-uk-margin> <div class=uk-form-row> <label class=uk-form-label>Your Name</label> <input v-model=user.name class=uk-form-width-large placeholder=\"e.g. John Simba\" v-validate:name=\"{ required: true, message: 'please put your name so that we can be friends :)' }\" initial=off :classes=\"{ valid: 'uk-form-success', invalid: 'uk-form-danger' }\" group=paymentgroup required> </div> <div class=uk-form-row> <label class=uk-form-label>Email Address</label> <div class=uk-form-icon><i class=uk-icon-inbox></i> <input type=email v-model=user.email class=uk-form-width-large placeholder=\"e.g. you@youremail.com\" v-validate:email=\"{ required: true, message: 'email requires an @ and a .', pattern: '/^[-a-z0-9~!$%^&*_=+}{\\'?]+(\\.[-a-z0-9~!$%^&*_=+}{\\'?]+)*@([a-z0-9_][-a-z0-9_]*(\\.[-a-z0-9_]+)*\\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}))(:[0-9]{1,5})?$/i' }\" initial=off :classes=\"{ valid: 'uk-form-success', invalid: 'uk-form-danger' }\" group=paymentgroup required> </div> </div> <div class=uk-form-row> <label class=uk-form-label>Phone Number</label> <div class=\"uk-form-icon uk-margin-small-top\"><i class=uk-icon-phone></i> <input type=tel v-model=user.phoneNumber class=uk-form-width-large placeholder=\"e.g. 0712123456\" v-validate:phonenumber=\"{ required: true, message: 'we will only use your number for good' }\" initial=off :classes=\"{ valid: 'uk-form-success', invalid: 'uk-form-danger' }\" group=paymentgroup required> </div> </div> <div class=\"uk-form-row uk-width-1-1\"> <p></p> <button class=\"uk-button uk-button-primary uk-button-large uk-align-center\" type=button v-if=$paymentvalidator.paymentgroup.valid v-on:click=confirm()>Pre-Order</button> </div> </form> </div> </div> </div> </validator> </div> <div v-if=confirmed> <div class=uk-modal-dialog> <a class=\"uk-modal-close uk-close\"></a> <div class=\"uk-align-center uk-text-center\"> <h2>Thanks for your order</h2> <i style=\"color: #87AB61\" class=\"fa fa-check-circle fa-5x\"></i><br> <h3>A Kuza representative will get back to you soon</h3> <h3>For inquiries call Isaac at</h3> <h2>+254718411704</h2> </div> </div> </div> ";

/***/ },
/* 41 */
/***/ function(module, exports) {

	module.exports = " <div class=kit v-if=kits> <div class=kit-header> <h2 class=uk-text-center>{{ kits[0].title }}</h2> </div> <div class=kit-body> <p class=uk-truncate> {{ kits[0].description }} </p> <ul class=\"uk-subnav uk-subnav-pill\" data-uk-switcher=\"{connect:'#my-id'}\"> <li><a href=\"\">Basic</a></li> <li><a href=\"\">Custom</a></li> </ul> <ul id=my-id class=uk-switcher> <li> <div class=uk-accordion data-uk-accordion> <h3 class=uk-accordion-title>Courses <span class=\"uk-badge uk-badge-notification\">{{ kits[0].packages.basic.courses.units }}</span> <i class=\"uk-icon uk-icon-caret-down uk-align-right\"></i></h3> <div class=uk-accordion-content> <p class=uk-truncate> {{ kits[0].packages.basic.courses.summary }} </p> </div> <h3 class=uk-accordion-title>Expert Support <i class=\"uk-icon uk-icon-check\"></i> <i class=\"uk-icon uk-icon-caret-down uk-align-right\"></i></h3> <div class=uk-accordion-content> <p class=uk-truncate> {{ kits[0].packages.basic.expertHours.summary }} </p> </div> <h3 class=uk-accordion-title>Farm Visits <span class=\"uk-badge uk-badge-notification\"> {{ kits[0].packages.basic.visits.units }} </span> <i class=\"uk-icon uk-icon-caret-down uk-align-right\"></i></h3> <div class=uk-accordion-content> <p class=uk-truncate> {{ kits[0].packages.basic.visits.summary }} </p> </div> <h3 class=uk-accordion-title>Prior Requirements <i class=\"uk-icon uk-icon-caret-down uk-align-right\"></i></h3> <div class=uk-accordion-content> <table class=uk-table> <thead> <tr> <th>Name</th> <th>Description</th> </tr> </thead> <tbody> <tr v-for=\"requirement in kits[0].packages.basic.requirements\"> <td> {{ requirement.name }} </td> <td> {{ requirement.description }} </td> </tr> </tbody> </table> </div> <h3 class=uk-accordion-title>Inputs <i class=\"uk-icon uk-icon-check\"></i> <i class=\"uk-icon uk-icon-caret-down uk-align-right\"></i></h3> <div class=\"uk-accordion-content uk-padding-remove\"> <table class=uk-table> <thead> <tr> <th>Item</th> <th>Units</th> <th>Cost</th> </tr> </thead> <tbody> <tr v-for=\"input in kits[0].packages.basic.inputs\"> <td>{{ input.title }}</td> <td>{{ input.units }}</td> <td>{{ input.kitPrice }}</td> </tr> </tbody> </table> </div> <h2 class=\"uk-text-right uk-margin-right uk-margin-bottom\"> Ksh. {{ kits[0].packages.basic.totalPrice }} </h2> <a class=\"uk-button uk-button-primary uk-button-large uk-clearfix uk-align-right\" href=#basic-payment-modal data-uk-modal> Pre-Order Now </a> </div> </li> <li> <div class=\"uk-accordion uk-panel uk-text-center\" data-uk-accordion> <div> <h2>Call</h2> <a href=tel:+254718411704 class=uk-h1> +254718411704 </a> <h2> or email </h2> <a href=mailto:farm@kuza.io class=uk-h1> farm@kuza.io </a> </div> </div> </li> </ul> </div> </div> <div id=basic-payment-modal class=\"uk-modal payment-modal\"> <payment-modal :total-price=kits[0].packages.basic.totalPrice></payment-modal> </div> ";

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(22)
	__vue_script__ = __webpack_require__(6)
	__vue_template__ = __webpack_require__(34)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(16)
	__vue_script__ = __webpack_require__(7)
	__vue_template__ = __webpack_require__(35)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(17)
	__vue_script__ = __webpack_require__(8)
	__vue_template__ = __webpack_require__(36)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(18)
	__vue_script__ = __webpack_require__(9)
	__vue_template__ = __webpack_require__(37)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(19)
	__vue_script__ = __webpack_require__(10)
	__vue_template__ = __webpack_require__(38)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(20)
	__vue_script__ = __webpack_require__(11)
	__vue_template__ = __webpack_require__(39)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(12)
	__vue_template__ = __webpack_require__(40)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.94903b6648f2cf663fce.js
 **/